import { useThree, useFrame } from '@react-three/fiber'
import { useRef, useEffect, useState } from "react"
import { KeyboardControls, useKeyboardControls } from "@react-three/drei"
import { CylinderCollider, RigidBody } from '@react-three/rapier';
import { Raycaster, Vector3, Object3D, LineBasicMaterial, BufferGeometry, Line } from 'three';
import { RayColliderIntersection } from '@dimforge/rapier3d-compat';



// const carDims = {x: 3, y: 1, z: 1.5};  // Half dimensions of the car
const camSpeedCoef = 0.1;
const carDims = {x: 5, y: 1, z: 3};  // Half dimensions of the car
const wheelRadius = 0.8;
const suspensionLength = 1*wheelRadius;
const suspensionK = 80;
const suspensionDamping = 2;
const maxSteerAngle = Math.PI/6;
const perfectGrip = 0.0005;
const gripCoeff = 1 * perfectGrip;
const frictionCoeff = 0.00002;
const wheelDims = {x: wheelRadius, y: wheelRadius/2, z: wheelRadius};
const wheelPos = {x: carDims.x/2 * 1.2/1.5, y: -(carDims.y + wheelDims.y)/2, z: carDims.z/2};
const jointFactorSize = 0.05;
const wheelRays = [new Raycaster(new Vector3(), new Vector3(), 0.1, suspensionLength), new Raycaster(new Vector3(), new Vector3(), 0.1, suspensionLength), new Raycaster(new Vector3(), new Vector3(), 0.1, suspensionLength), new Raycaster(new Vector3(), new Vector3(), 0.1, suspensionLength)];
const groundDirection = new Vector3(0, -1, 0);
const jointPositions = [new Vector3(0, 0 ,0), new Vector3(0, 0 ,0), new Vector3(0, 0 ,0), new Vector3(0, 0 ,0)];
// const rayWheel1 = new Raycaster();
// const rayWheel2 = new Raycaster();
// const rayWheel3 = new Raycaster();
// const rayWheel4 = new Raycaster();

export default function Car(){
    const wheel1Ref = useRef(null);
    const wheel2Ref = useRef(null);
    const wheel3Ref = useRef(null);
    const wheel4Ref = useRef(null);
    const wheelRefs = [wheel1Ref, wheel2Ref, wheel3Ref, wheel4Ref];
    // const videoElement = document.getElementsByClassName('input_video')[0];
    const carRef = useRef(null);
    const ref = useRef(null);
    const [subscribeKeys, getKeys] = useKeyboardControls();
    const acceleration = 100;
    const rotationTorque = 2;
    const [accelerate, setAccelerate] = useState("");
    const [turn, setTurn] = useState("");
    const { camera, gl } = useThree();

    // camera.position.set(-50, 50, -50);
    // camera.lookAt(new Vector3(0, 0, 0));

    useEffect(() => {
        const moveCar = event => {
            // console.log(event);
            // accelerate
            if (event.type == "moveDirection"){
                if (event.detail=='forward') {
                    setAccelerate('moveForward');
                } else if (event.detail=='backward') {
                    setAccelerate('moveBackward');
                } else if (event.detail=='none') {
                    setAccelerate('none');
                }
            }
            // turn
            if (event.type == "turnDirection"){
                if (event.detail=='rightward') {
                    setTurn('moveRight');
                } else if (event.detail=='leftward') {
                    setTurn('moveLeft');
                } else if (event.detail=='none') {
                    setTurn('none');
                }
            }
        };
        // carRef.current.setAdditionalMassProperties(
        //     100,                        // Mass.
        //     { x: 0.0, y: 0.5, z: 0.0 }, // Center of mass.
        //     // { x: 0.3, y: 0.2, z: 0.1 }, // Principal angular inertia.
        //     // { w: 1.0, x: 0.0, y: 0.0, z: 0.0 } // Principal angular inertia frame (unit quaternion).
        // );
        
        // const sceneObj = Object3D.getObjectByName("IWantName");
        window.addEventListener('moveDirection', moveCar);
        window.addEventListener('turnDirection', moveCar);
    
        return () => {
            window.removeEventListener('moveDirection', moveCar);
            window.removeEventListener('turnDirection', moveCar);
        };
      }, []);
    
    const vertical = new Vector3(0, 1, 0);
    const zero = new Vector3(0, 0, 0);
    var intersections = [];
    var steerAngle = [];

    useFrame((state, delta) => {
        // console.log(carRef.current.collider());
        const { forward, backward, leftward, rightward, reset } = getKeys();
        const angle = 180/Math.PI*(2 * Math.asin(carRef.current.rotation().y)) * Math.sign(carRef.current.rotation().y);
        const carFront = new Vector3( 1, 0, 0 );
        const carUp = new Vector3 ( 0, 1, 0 );
        const carRight = new Vector3( 0, 0, 1 );
        carFront.applyQuaternion(carRef.current.rotation());
        carUp.applyQuaternion(carRef.current.rotation());
        carRight.applyQuaternion(carRef.current.rotation());
        
        // Compute joints positions for the suspensions
        // front-right
        jointPositions[0].addVectors(carRef.current.translation(), carFront.clone().multiplyScalar(wheelPos.x));
        jointPositions[0].addScaledVector(carRight, wheelPos.z);
        jointPositions[0].addScaledVector(carUp, -carDims.y);
        
        // front-left
        jointPositions[1].addVectors(carRef.current.translation(), carFront.clone().multiplyScalar(wheelPos.x));
        jointPositions[1].addScaledVector(carRight, -wheelPos.z);
        jointPositions[1].addScaledVector(carUp, -carDims.y);
        // back-right
        jointPositions[2].addVectors(carRef.current.translation(), carFront.clone().multiplyScalar(-wheelPos.x));
        jointPositions[2].addScaledVector(carRight, wheelPos.z);
        jointPositions[2].addScaledVector(carUp, -carDims.y);
        // back-left
        jointPositions[3].addVectors(carRef.current.translation(), carFront.clone().multiplyScalar(-wheelPos.x));
        jointPositions[3].addScaledVector(carRight, -wheelPos.z);
        jointPositions[3].addScaledVector(carUp, -carDims.y);

        var suspensionForces = [];
        var compressions = [0, 0, 0, 0];
        var gripForces = [];
        var frictionForces = [];

        for (let i = 0; i < 4; i++) {
            wheelRays[i].set(jointPositions[i], carUp.clone().multiplyScalar(-1).normalize());
            intersections = wheelRays[i].intersectObjects(state.scene.children);
            
            // console.log(intersections);
            // console.log(carRef.current);
            if (i<2) {
                if (turn=="moveRight" || rightward) {
                    steerAngle = -maxSteerAngle;
                } else if (turn=="moveLeft" || leftward){
                    steerAngle = maxSteerAngle;
                }
            } else {
                steerAngle = 0;
            }
            
        
            if (intersections.length > 0) {
                // Suspension
                const compression = suspensionLength - intersections[0].distance;
                const relativePos = jointPositions[i].clone().addScaledVector(carRef.current.translation(), -1);
                const relativeVel = new Vector3(carRef.current.angvel().x, carRef.current.angvel().y, carRef.current.angvel().z).cross(relativePos);
                const localVelocity = new Vector3().addVectors(carRef.current.linvel(), relativeVel);
                const F = -suspensionK * compression + suspensionDamping*localVelocity.clone().dot(carUp);
                const vectF = carUp.clone().multiplyScalar(-F);
                suspensionForces.push(vectF);
                compressions[i] = compression;
                // Steering
                const centrifugalSpeed = localVelocity.clone().dot(carRight.clone().applyAxisAngle(carUp, steerAngle));
                const gripFNorm = -carRef.current.mass() * centrifugalSpeed/delta * gripCoeff;
                const gripF = carRight.clone().applyAxisAngle(carUp, steerAngle).normalize().multiplyScalar(gripFNorm);
                gripForces.push(gripF);
                const forwardSpeed = localVelocity.clone().dot(carFront.clone().applyAxisAngle(carUp, steerAngle));
                const frictionFNorm = -carRef.current.mass() * forwardSpeed/delta * frictionCoeff;
                const frictionF = carFront.clone().applyAxisAngle(carUp, steerAngle).normalize().multiplyScalar(frictionFNorm);
                frictionForces.push(frictionF);
                // console.log(carRef.current.mass());
                // console.log(gripF);
            } else {
                frictionForces.push(zero);
                suspensionForces.push(zero);
                gripForces.push(zero);
            }
        }

        const Forces = suspensionForces;
        for (let i = 0; i < 4; i++) {
            if (i<2) {
                if (turn=="moveRight" || rightward) {
                    steerAngle = -maxSteerAngle;
                } else if (turn=="moveLeft" || leftward){
                    steerAngle = maxSteerAngle;
                }
            } else {
                steerAngle = 0;
            }
            // Suspensions
            carRef.current.applyImpulseAtPoint(Forces[i], jointPositions[i], true);
            // Grip to steer
            carRef.current.applyImpulseAtPoint(gripForces[i], jointPositions[i], true);
            // Ground friction
            carRef.current.applyImpulseAtPoint(frictionForces[i], jointPositions[i], true);
            // Place wheels
            const wheelCenterPos = jointPositions[i].clone().addScaledVector(carUp, compressions[i]);
            // Rotate wheels
            wheelRefs[i].current.position.set(wheelCenterPos.x, wheelCenterPos.y, wheelCenterPos.z);
            wheelRefs[i].current.setRotationFromQuaternion(carRef.current.rotation());
            wheelRefs[i].current.rotateOnWorldAxis(carFront, Math.PI/2);
            if (i<2) {
                wheelRefs[i].current.rotateOnWorldAxis(carUp, steerAngle);
            }
            // // Steering
            // const 
            // const wheelAcc = /delta
        }
        wheelRays.forEach((ray) => {
            // console.log(ray);
            // const material = new LineBasicMaterial({ color: 0xff0000 });
            // const geometry = new BufferGeometry().setFromPoints([ray.ray.origin, ray.ray.origin.clone().addScaledVector(ray.ray.direction, ray.far)]);
            // const line = new Line(geometry, material);
            // line.position.copy(0);
            // line.computeLineDistances();
            // state.scene.add(line);
            // console.log(line);
        });


        if(accelerate=="moveForward") {
            // console.log('ok');
            carRef.current.applyImpulse({ x: carFront.x * delta * acceleration, y: 0, z: carFront.z * delta * acceleration }, true);
        }
        if(accelerate=="moveBackward") {
            carRef.current.applyImpulse({ x: -carFront.x * delta * acceleration, y: 0, z: -carFront.z * delta * acceleration }, true);
        }
        if(turn=="moveRight") {
            // carRef.current.applyTorqueImpulse( {x: 0, y:-delta*rotationTorque, z: 0} );
        }
        if(turn=="moveLeft") {
            // carRef.current.applyTorqueImpulse( {x: 0, y:delta*rotationTorque, z: 0} );
        }
        if(forward) {
            carRef.current.applyImpulse({ x: carFront.x * delta * acceleration, y: 0, z: carFront.z * delta * acceleration }, true);
            // carRef.current.applyImpulseAtPoint({ x: 0.0, y: 0.6, z: 0.0 }, jointPositions[3],true);
            // console.log(jointPositions[3]);
        }
        if(backward) {
            carRef.current.applyImpulse({ x: -carFront.x * delta * acceleration, y: 0, z: -carFront.z * delta * acceleration }, true);
        }
        if(rightward) {
            // carRef.current.applyTorqueImpulse( {x: 0, y:-delta*rotationTorque, z: 0} );
        }
        if(leftward) {
            // carRef.current.applyTorqueImpulse( {x: 0, y:delta*rotationTorque, z: 0} );
        }
        // carRef.current.setLinvel(direction.multiplyScalar(carRef.current.linvel().length()));

        if(reset) {
            carRef.current.position.x = 0;
            carRef.current.position.y = 2;
            carRef.current.position.z = 0;
        }

        // camera
        // try {
        const carPosition = carRef.current.translation();
        const carRotation = carRef.current.rotation();
        // console.log(carRef.current.translation());
        // if (carRef.current!=null) {
        try{
            // const angleShift = carRef.current.angvel().z;
            // // const camShift = zero.crossVectors(vertical, carFront).multiplyScalar(100*angleShift);
            // // console.log(angleShift);
            // // const newPosition = new Vector3(carPosition.x, carPosition.y+7, carPosition.z).addScaledVector(direction, -10).add(camShift);
            // const newPosition = new Vector3(carPosition.x, carPosition.y+7, carPosition.z).addScaledVector(carFront, -25);
            // // console.log(camShift);
            // // console.log(camera);
            // const camSpeed = new Vector3().addVectors(newPosition, camera.position.clone().multiplyScalar(-1)).multiplyScalar(camSpeedCoef);
            // const camNewPos = camera.position.clone().add(camSpeed);
            // // camera.position.set(newPosition.x, newPosition.y, newPosition.z);
            // //camera.position.set(camNewPos.x, camNewPos.y, camNewPos.z);
            // camera.position.lerp(newPosition, 0.2);
            // camera.lookAt(new Vector3(carPosition.x, carPosition.y+3, carPosition.z));
            // // console.log('ok');


        } catch {}
        // } catch {}
    });
    
    
    return <>
        <group position-y={3} castShadow={ true }>
            <perspectiveCamera args = { [camera, gl] } />
            <RigidBody ref={carRef} type="dynamic" friction={ 0.7 } restitution={0.2}>
            <mesh className="car-body" position= { [0, 0, 0] } scale={ [carDims.x, carDims.y, carDims.z] } castShadow={ true }>
                <boxBufferGeometry attach="geometry" />
                <meshStandardMaterial attach="material" color="green" />
            </mesh>
            {/* <mesh className="joint-1" position= { [wheelPos.x, wheelPos.y, wheelPos.z] } rotation-x={ - Math.PI * 0.5 } scale={ [wheelDims.x*jointFactorSize, wheelDims.y*jointFactorSize, wheelDims.z*jointFactorSize] }>
                <cylinderGeometry attach="geometry" />
                <meshLambertMaterial attach="material" color="black" />
            </mesh>
            <mesh className="joint-2" position= { [wheelPos.x, wheelPos.y, -wheelPos.z] } rotation-x={ - Math.PI * 0.5 } scale={ [wheelDims.x*jointFactorSize, wheelDims.y*jointFactorSize, wheelDims.z*jointFactorSize] }>
                <cylinderGeometry attach="geometry" />
                <meshLambertMaterial attach="material" color="black" />
            </mesh>
            <mesh className="joint-3" position= { [-wheelPos.x, wheelPos.y, wheelPos.z] } rotation-x={ - Math.PI * 0.5 } scale={ [wheelDims.x*jointFactorSize, wheelDims.y*jointFactorSize, wheelDims.z*jointFactorSize] }>
                <cylinderGeometry attach="geometry" />
                <meshLambertMaterial attach="material" color="black" />
            </mesh>
            <mesh className="joint-4" position= { [-wheelPos.x, wheelPos.y, -wheelPos.z] } rotation-x={ - Math.PI * 0.5 } scale={ [wheelDims.x*jointFactorSize, wheelDims.y*jointFactorSize, wheelDims.z*jointFactorSize] }>
                <cylinderGeometry attach="geometry" />
                <meshLambertMaterial attach="material" color="black" />
            </mesh> */}
            </RigidBody>
            
        </group>
        <mesh className="wheel-1" ref={wheel1Ref} position= { [0, 0, 0] } rotation-x={ - Math.PI * 0.5 } scale={ [wheelDims.x, wheelDims.y, wheelDims.z] }>
            <cylinderGeometry attach="geometry" />
            <meshLambertMaterial attach="material" color="transparent" />
        </mesh>
        <mesh className="wheel-2" ref={wheel2Ref} position= { [0, 0, 0] } rotation-x={ - Math.PI * 0.5 } scale={ [wheelDims.x, wheelDims.y, wheelDims.z] }>
            <cylinderGeometry attach="geometry" />
            <meshLambertMaterial attach="material" color="black" />
        </mesh>
        <mesh className="wheel-3" ref={wheel3Ref} position= { [0, 0, 0] } rotation-x={ - Math.PI * 0.5 } scale={ [wheelDims.x, wheelDims.y, wheelDims.z] }>
            <cylinderGeometry attach="geometry" />
            <meshLambertMaterial attach="material" color="black" />
        </mesh>
        <mesh className="wheel-4" ref={wheel4Ref} position= { [0, 0, 0] } rotation-x={ - Math.PI * 0.5 } scale={ [wheelDims.x, wheelDims.y, wheelDims.z] }>
            <cylinderGeometry attach="geometry" />
            <meshLambertMaterial attach="material" color="black" />
        </mesh>
    </>
}